import React from 'react';
import { Box, Button } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';

import ButtonWithLoader from '../../../ButtonWithLoader';
import Dialog from '../../../DesignSystem/Dialog';
import FormFolderPickerRadios from '../../Forms/Common/FormFolderPickerRadios/FormFolderPickerRadios';
import { PostTypes } from '../../../../Utils/Types';
import usePostsQuery from '../../../../Hooks/usePostsQuery';
import usePostMutation from '../../../../Hooks/usePostMutation';
import useSpace from '../../../../Hooks/useSpace';
import { useNotifications } from '@toolpad/core/useNotifications';
import { notify } from '../../../../Utils/NotificationUtils';

function AddToFolderModal({ title, open, onClose, post }: any) {
  const { space } = useSpace();
  const intl = useIntl();
  const notifications = useNotifications();
  const { posts } = usePostsQuery(`folders-${space.slug}`, {
    limit: 9999,
    types: [PostTypes.FOLDER],
    space,
    page: 0,
    useQueryProps: {
      keepPreviousData: false,
      cacheTime: 0,
      enabled: open,
    },
  });

  // Exclude current folder to avoid circular reference
  const folders = posts.filter((folder: any) => folder.id !== post.id);

  const { mutate: updatePost, isLoading } = usePostMutation({
    post,
    isEdit: true,
    isDashboard: true,
    intl,
    notifications,
  });

  const updateParent = (data: any) => {
    return updatePost(data, {
      onSuccess: () => {
        onClose();

        if (data.post_record_id) {
          notify(
            notifications,
            intl.formatMessage({ id: 'POSTS.CREATE_MENU.ADDED_TO_FOLDER_TOAST' }),
          );
        } else {
          notify(
            notifications,
            intl.formatMessage({ id: 'POSTS.CREATE_MENU.REMOVED_FROM_FOLDER_TOAST' }),
          );
        }
      },
    });
  };

  const { handleSubmit, control } = useForm({
    reValidateMode: 'onChange',
    defaultValues: {
      post_record_id: post?.parent_id?.toString(),
    },
  });

  const dialogActions = (
    <>
      <Button variant="outlined" size="large" onClick={onClose} color="primary">
        <FormattedMessage id="BUTTONS.CANCEL" />
      </Button>
      <ButtonWithLoader
        isFetching={isLoading}
        variant="contained"
        size="large"
        onClick={handleSubmit(updateParent)}
        color="primary"
        disabled={isLoading}
      >
        <FormattedMessage id="COMMENTS.CREATION.VALIDATE" />
      </ButtonWithLoader>
    </>
  );

  return (
    <Dialog
      id="asssign-parent-form-dialog"
      label="asssign-parent-form-dialog"
      title={title}
      open={open}
      onClose={onClose}
      actions={dialogActions}
    >
      <Box sx={{ mt: 1 }}>
        <form onSubmit={handleSubmit(updateParent)}>
          <FormFolderPickerRadios control={control} posts={folders} />
        </form>
      </Box>
    </Dialog>
  );
}

export default AddToFolderModal;
